class EventData {
  constructor(name) {
    this.intValue = 0;
    this.floatValue = 0;
    this.stringValue = null;
    this.audioPath = null;
    this.volume = 0;
    this.balance = 0;
    this.name = name;
  }
}

export { EventData };
//# sourceMappingURL=EventData.mjs.map
